var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.loading}},[_c('input',{ref:"file",staticClass:"invisible",staticStyle:{"width":"0","height":"0"},attrs:{"accept":"image/*","type":"file","multiple":""},on:{"change":_vm.upload}}),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.pick}},[_vm._v(" Upload to "+_vm._s(_vm.prefix)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }